export const BONUS_DISPLAY_ORDER = [
  'apparizione',
  'apparizione_ple',
  'interferenza_ple',
  'entrata_speciale',
  'match_sett',
  'match_ple',
  'vince_sett',
  'vince_ple',
  'vince_match_3_6',
  'vince_match_6_plus',
  'vince_match_3_4_ple',
  'vince_match_5_6_ple',
  'vince_match_6_plus_ple',
  'stipulazione_speciale',
  'n1_contender',
  'main_event_ple',
  'main_event_wm',
  'opener',
  'main_event',
  'opp_titolata',
  'opp_titolata_mondiale',
  'mantiene_titolo',
  'vince_titolo_tag',
  'vince_titolo_singolo',
  'vince_titolo_massimo',
  'doppio_campione',
  'vince_mitb',
  'vince_kor',
  'vince_royal_rumble',
  'runner_up',
  'eliminazione',
  'sanguinamento',
  'coro',
  'turn',
  'forma_team',
  'ritorno_sorpresa',
  'arbitro_speciale',
  'spacca_oggetto',
  'spacca_ring',
  'debutto_main_roster',
  'hall_of_fame',
  'nomina_nxt_awards',
  'vince_nxt_awards',
  'nominato_slammy',
  'vince_slammy',
  'voto_alto',
  'roll_up_win',
  'roll_up_ple',
  'botch',
  'pareggio',
  'voto_basso',
  'campione_meno_40',
  'campione_meno_10',
  'no_difesa_3mesi',
  'ritiro',
  'lascia_wwe',
];

const SHOW_TYPE_TO_CATEGORY = {
  weekly: 'sett',
  'weekly-special': 'sett',
  ple: 'ple',
  'ple-free': 'ple',
};

export const getShowBonusCategory = (showData) => (
  SHOW_TYPE_TO_CATEGORY[showData?.type] || null
);

export const getBonusPointsForShow = (bonus, showData) => {
  if (!bonus) return null;

  if (showData?.isExtra) {
    return typeof bonus.pointsExt === 'number' ? bonus.pointsExt : null;
  }

  return typeof bonus.points === 'number' ? bonus.points : null;
};

export const getStoredBonusDisplay = (storedValue, bonusLookup, showData, assignedPoints = null) => {
  const value = String(storedValue || '');
  const isExtVariant = value.endsWith('_ext');
  const baseValue = isExtVariant ? value.slice(0, -4) : value;
  const bonus = typeof bonusLookup === 'function'
    ? bonusLookup(baseValue)
    : bonusLookup?.[baseValue.toLowerCase()] || bonusLookup?.[baseValue];
  const normalizedAssignedPoints = assignedPoints === null || assignedPoints === undefined || assignedPoints === ''
    ? null
    : Number(assignedPoints);
  const points = Number.isFinite(normalizedAssignedPoints)
    ? normalizedAssignedPoints
    : isExtVariant && typeof bonus?.pointsExt === 'number'
      ? bonus.pointsExt
      : getBonusPointsForShow(bonus, showData);

  return {
    value,
    baseValue,
    bonus,
    label: bonus?.label || value,
    desc: bonus?.desc || bonus?.description || '',
    points: typeof points === 'number' ? points : 0,
    isExtVariant,
  };
};

export const isBonusAvailableForShow = (bonus, showData) => {
  const showCategory = getShowBonusCategory(showData);
  if (!showCategory) return false;
  if (!(bonus.cat === 'both' || bonus.cat === showCategory)) return false;

  return getBonusPointsForShow(bonus, showData) !== null;
};

export const sortBonusesByConfiguredOrder = (bonuses) => {
  const orderMap = new Map(BONUS_DISPLAY_ORDER.map((value, index) => [value, index]));

  return [...bonuses].sort((first, second) => {
    const firstIndex = orderMap.has(first.value) ? orderMap.get(first.value) : Number.MAX_SAFE_INTEGER;
    const secondIndex = orderMap.has(second.value) ? orderMap.get(second.value) : Number.MAX_SAFE_INTEGER;

    if (firstIndex !== secondIndex) {
      return firstIndex - secondIndex;
    }

    return (first.label || '').localeCompare(second.label || '', 'it');
  });
};

export const getOrderedBonusesForShow = (bonusList, showData) => (
  sortBonusesByConfiguredOrder(
    bonusList.filter((bonus) => isBonusAvailableForShow(bonus, showData))
  )
);
